module.exports = __webpack_public_path__ + "static/Banner-36-7e6eb67c92c51eb7ffbb7c60e454267d.png";